function Row({ children }) {
  return (
    <span className="flex shrink-0 items-center">
      <span className="display-m flex items-center gap-8 pr-8 md:gap-12 md:pr-12">
        {children.map((t, i) => (
          <span key={i} className="flex items-center gap-8 md:gap-12">
            <span className={i % 2 === 1 ? 'text-haze' : ''}>{t}</span>
            <svg viewBox="0 0 24 24" className="h-4 w-4 text-[#FF6B35]" fill="currentColor" aria-hidden="true">
              <path d="M12 2c.6 4.5 2 7.4 3.6 9C17.2 12.6 20 13 22 13c-2 .8-4.6 1.6-6.4 3.2C14 17.8 12.6 20 12 22c-.6-2-2-4.2-3.6-5.8C6.6 14.6 4 13.8 2 13c2 0 4.8-.4 6.4-2C10 9.4 11.4 6.5 12 2z" />
            </svg>
          </span>
        ))}
      </span>
    </span>
  )
}

const PHRASES = [
  'Simple enough to understand',
  'Easy enough to follow',
  'Real enough for everyday life',
  'Built to keep you going',
]

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-[var(--line)] py-7 md:py-9"
      data-testid="brand-marquee"
      aria-label="Brand principles ticker"
    >
      <div className="marquee-track">
        <Row>{PHRASES}</Row>
        <Row aria-hidden="true">{PHRASES}</Row>
      </div>
    </div>
  )
}
